import React, { useState } from 'react';
import { DraggableModal, DraggableModalProvider } from 'ant-design-draggable-modal';
import { Select } from 'antd';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-ftl';
import 'ace-builds/src-noconflict/theme-github';
import './textareaeditmodal.less';

type TextareaEditModalProps = {
  visible: boolean;
  onCancel?: () => void;
  onConfirm?: (code: string, language: string) => void;
  value: string;
};

const TextareaEditModal = ({
  visible,
  onCancel,
  onConfirm,
  value,
}: TextareaEditModalProps): JSX.Element => {
  const lines = value.split(/\r?\n/);
  const p = lines[0] && lines[0].indexOf('!');
  const lang = p ? lines[0].substring(p + 1) : '';
  lines.shift();
  const [code, setCode] = useState(lines.join('\n'));
  const [language, setLanguage] = useState<string>(lang);
  return (
    <DraggableModalProvider>
      <DraggableModal
        open={visible}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={onCancel}
        onOk={() => onConfirm && onConfirm(code, language)}
        okText="Close"
        initialWidth={500}
        initialHeight={500}
      >
        <div className="ant-modal-body__content wrapper">
          <span>Language:</span>
          &nbsp;
          <Select
            style={{ width: '180px' }}
            options={[{ label: 'Javascript', value: 'javascript' }, { label: 'Freemarker', value: 'ftl' }, { label: 'JSON', value: 'json' }]}
            value={language}
            onChange={(v: string) => setLanguage(v)}
          />
          <br />
          <AceEditor
            mode={language}
            theme="github"
            onChange={(v: string) => setCode(v)}
            name="rule_ace_editor_code"
            editorProps={{ $blockScrolling: true }}
            value={code}
            style={{ width: '100%', height: '100vh' }}
          />
        </div>
      </DraggableModal>
    </DraggableModalProvider>
  );
};

TextareaEditModal.displayName = 'TextareaEditModal';

export default TextareaEditModal;
